var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item)?_c('div',[_c('h4',[_vm._v("Входные данные")]),_c('pre',{staticClass:"prettyprint"},[_c('code',[_vm._v(" "+_vm._s(_vm.item.data)+" ")])]),_c('hr'),_c('h4',[_vm._v("Ответ")]),_c('pre',{staticClass:"prettyprint"},[_vm._v(" "),_c('code',[_vm._v(" "+_vm._s(_vm.item.response)+"  ")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }